export default {"src":"/_next/static/media/unified-data-repository.676d47e2.svg","height":830,"width":726,"blurWidth":0,"blurHeight":0};